import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  withCredentials: true,
});

export default api;
